import { formatPrizeAmount, isAverageRanking } from "@/lib/prizes";
import { formatRoom } from "@/lib/classroom";
import { cn } from "@/lib/utils";

/**
 * Who leads (or won) each division for a top-classroom prize, one line
 * each: "Division 1: Room 12 leading · 45 min per student". Staff views
 * only — it names classrooms.
 *
 * prize: { kind, ranked_by, finalized, divisions: [{ label, leaders: [{ id, name }], leader_amount }] }
 */
export default function DivisionLeaderList({ prize, className }) {
  if (prize.divisions.length === 0) {
    return <p className={cn("text-xs text-muted-foreground", className)}>No classrooms with students yet.</p>;
  }
  const unit = isAverageRanking(prize.ranked_by) ? " per student" : "";

  return (
    <ul className={cn("space-y-0.5 text-xs text-muted-foreground", className)}>
      {prize.divisions.map((d) => (
        <li key={d.label}>
          <span className="font-medium text-foreground">{d.label}:</span>{" "}
          {d.leaders.length === 0 ? (
            prize.finalized ? "no class qualified" : "no class has qualified yet"
          ) : (
            <>
              {d.leaders.map((c) => formatRoom(c.name)).join(", ")}
              {prize.finalized ? " won" : d.leaders.length > 1 ? " tied for 1st" : " leading"}
              {d.leader_amount != null && <span className="font-tabular"> · {formatPrizeAmount(prize.kind, d.leader_amount)}{unit}</span>}
            </>
          )}
        </li>
      ))}
    </ul>
  );
}
